import React, { useState, useEffect } from "react";
import GenericDropdown from "../../../../../components/generic/genericDropdown";
import MarkClosed from "./markClosed"

export default function ClosedAccountsRowDropdown(props) {
  const [markedClosed, setMarkedClosed] = useState(props.markedClosed)
  const [dropdownItems, setDropdownItems] = useState([]);

  useEffect(() => {
    setMarkedClosed(props.record.account.marked_closed)
  }, [props]);

  useEffect(() => {
    let newDropdownItems = []
    if (markedClosed) {
      newDropdownItems.push(<MarkClosed 
        markedClosed={markedClosed}
        bankAccountId={props.record.id}
        setClosedAccounts={props.setClosedAccounts}
        setConnectedAccounts={props.setConnectedAccounts}
        record={props.record}
      />)
    }
    
    setDropdownItems(newDropdownItems)

  }, [markedClosed, props.record])


  return(
    <GenericDropdown 
      dropdownItems={dropdownItems}
    />
  )
};